<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="vx-navbar-wrapper navbar-full p-0" >
    <vs-navbar class="navbar-custom navbar-skelton " :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">
      
      <div class="vx-logo cursor-pointer mx-auto flex items-center">
          <a href="https://www.flairboat.com" target="_blank" class="flex">
              <!-- <span class="vx-logo-text text-3xl text-primary">Flairboat</span>
        <div class="w-10  fill-current text-primary" >
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1070 1180" preserveAspectRatio="xMidYMid meet">
<g id="layer101" fill="#1459fc" stroke="none">
 <path d="M60 1106 c0 -2 114 -109 253 -236 138 -128 262 -243 275 -254 l22 -22 -275 -253 c-151 -140 -275 -257 -275 -262 0 -5 78 -9 173 -9 l172 0 283 262 284 261 -34 33 c-18 18 -143 134 -278 258 l-245 226 -177 0 c-98 0 -178 -2 -178 -4z"/>
 </g>
<g id="layer102" fill="#ffcc01" stroke="none">
 <path d="M60 1106 c0 -5 479 -449 536 -496 23 -19 77 -67 121 -107 l79 -72 89 82 88 82 -279 258 -279 257 -177 0 c-98 0 -178 -2 -178 -4z"/>
 </g>

</svg>
        </div> -->
        <img src ="./flairboat.png" class="vx-logo " width="270px">
        
          </a>
      </div>

    </vs-navbar>
  </div>

</template>

<script>


import Logo                 from "../Logo.vue"

export default {
  name: "the-navbar-login",
  props: {
    logo: { type: String                                                                                                         
     },
    // navbarType: {
    //   type: String,
    //   required: true
    // }
  },
  data(){
    return{
      navbarType : "static"
    }
  },
  components: {
    Logo,
    
  },
  computed: {
    navbarColor() {
      let color = "#fff"
      if (this.navbarType === "sticky") color = "#f7f7f7"
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = "#f7f7f7"
        }
      }

      this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

      return color
    },
    isThemedark()          { return this.$store.state.theme                                                                       },
    navbarStyle()          { return this.navbarType === "static" ? {transition: "all .25s ease-in-out"} : {}                      },
    navbarClasses()        { return  "d-theme-dark-light-bg shadow-none" },
    scrollY()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth()          { return this.$store.state.windowWidth                                                                 },
  },
  
}

</script>
<style>
.vx-navbar-wrapper{
  background-shadow:none;
}
</style>
